import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  DateInput,
  ReferenceInput,
  AutocompleteInput,
  required,
  TopToolbar,
  ListButton,
  useNotify,
  useRedirect,
} from 'react-admin';
import { Grid, Card, CardContent, Typography } from '@mui/material';

const CreateActions = () => (
  <TopToolbar>
    <ListButton />
  </TopToolbar>
);

export const OpportunityCreate = () => {
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = (data: any) => {
    notify('Opportunity created successfully', { type: 'success' });
    redirect('show', 'opportunities', data.id);
  };

  return (
    <Create actions={<CreateActions />} mutationOptions={{ onSuccess }}>
      <SimpleForm>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Opportunity Details
              </Typography>
              <TextInput source="name" label="Opportunity Name" validate={[required()]} fullWidth />
              <NumberInput
                source="value"
                label="Value ($)"
                validate={[required()]}
                fullWidth
                min={0}
              />
              <NumberInput
                source="probability"
                label="Probability (%)"
                fullWidth
                min={0}
                max={100}
                defaultValue={0}
              />
              <DateInput 
                source="expectedCloseDate" 
                label="Expected Close Date" 
                fullWidth 
                parse={(value) => {
                  if (!value) {return null;}
                  // Handle both date strings and ISO datetime strings
                  const date = new Date(value + (value.includes('T') ? '' : 'T00:00:00'));
                  return date.toISOString();
                }}
                format={(value) => {
                  if (!value) {return '';}
                  // Handle both ISO datetime strings and date strings
                  return value.includes('T') ? value.split('T')[0] : value;
                }}
              />
              <ReferenceInput source="stageId" reference="board-stages" label="Stage">
                <AutocompleteInput optionText="name" fullWidth />
              </ReferenceInput>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Relationships
              </Typography>
              <ReferenceInput source="customerId" reference="customers" label="Customer">
                <AutocompleteInput optionText="displayName" fullWidth />
              </ReferenceInput>

              <ReferenceInput source="boardId" reference="boards" label="Board">
                <AutocompleteInput optionText="name" fullWidth />
              </ReferenceInput>

              <ReferenceInput source="assignedUserId" reference="users" label="Assigned User">
                <AutocompleteInput optionText="name" fullWidth />
              </ReferenceInput>

              <NumberInput source="sortOrder" label="Sort Order" fullWidth defaultValue={0} />
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Description
              </Typography>
              <TextInput source="description" label="Description" multiline rows={4} fullWidth />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </SimpleForm>
  </Create>
  );
};
